import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import PushNotifications from "../../components/Notification";

const PushNotificationPage = (): ReactElement => {
  return (
    <Layout>
      <PushNotifications />
    </Layout>
  );
};

export default PushNotificationPage;
